import * as React from "react";
import { Tag } from "@grandvisionhq/common";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const ProductTag = ({ className }) => {
  const {
    activeVariant: { productTag }
  } = useProductData();
  if (!productTag || productTag.value === "") {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Tag, { className, iconKey: productTag.iconKey, label: productTag.value });
};
export {
  ProductTag
};
//# sourceMappingURL=ProductTag.js.map
